import request from '@/util/request'

export function getAllAddressDetail(query) {
  return request({
    url: '/address/allDetail',
    method: 'get',
    params: query,
  })
}

export function addAddress(data) {
  return request({
    url: '/address/add',
    method: 'post',
    data,
  })
}

export function amendAddress(data) {
  return request({
    url: '/address/amend',
    method: 'post',
    data,
  })
}

export function deleteAddress(data) {
  return request({
    url: '/address/delete',
    method: 'post',
    data,
  })
}

export function setAddressDefault(data) {
  return request({
    url: '/address/setDefault',
    method: 'post',
    data,
  })
}
